var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"resend-tooltip",attrs:{"content":_vm.errorMessage,"placement":"bottom"}},[_c('i',{staticClass:"el-icon-warning error-icon",class:{ '!hidden': !_vm.isVisible, '!inline': _vm.isVisible },attrs:{"disabled":_vm.buttonDisabled},on:{"click":function($event){return _vm.resendMessage()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }